const config = {
    BACKEND: "https://api.dme-tech.ru/api/v2/",
    PAYPALCLIENTID: "AU2hUPPMuIczHydZf1EYoFk3dlivWWNLJy9uEXqq_aYpK4czHAUm62z8Vy4GtaJWxtl7dg27QITPBMBv",
    debugMode: false,
  };
  
  export default config;